<template>
  <div :style="`width:${width};margin:0 auto;`">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1200 1200"
      width="1200"
      height="1200"
      preserveAspectRatio="xMidYMid meet"
      style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;"
    >
      <defs>
        <clipPath id="__lottie_element_2"><rect width="1200" height="1200" x="0" y="0"></rect></clipPath>
        <linearGradient id="__lottie_element_6" spreadMethod="pad" gradientUnits="userSpaceOnUse" x1="-280" y1="0" x2="280" y2="0">
          <stop offset="0%" stop-color="rgb(223,236,250)"></stop>
          <stop offset="50%" stop-color="rgb(236,244,252)"></stop>
          <stop offset="100%" stop-color="rgb(250,252,255)"></stop>
        </linearGradient>
        <linearGradient id="__lottie_element_10" spreadMethod="pad" gradientUnits="userSpaceOnUse" x1="-200" y1="0" x2="200" y2="0">
          <stop offset="0%" stop-color="rgb(233,240,250)"></stop>
          <stop offset="50%" stop-color="rgb(224,236,248)"></stop>
          <stop offset="100%" stop-color="rgb(216,232,245)"></stop>
        </linearGradient>
      </defs>
      <g clip-path="url(#__lottie_element_2)">
        <g transform="matrix(1,0,0,1,400,630.0374145507812)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <!-- sol büyük yüz -->
            <path
              fill="#ecf3f9"
              fill-opacity="1"
              d=" M280,-320 C280,-320 -280,-320 -280,-320 C-280,-320 -280,320 -280,320 C-280,320 280,320 280,320 C280,320 280,-320 280,-320z"
            ></path>
          </g>
        </g>
        <g transform="matrix(1,0,0,1,880,630.0374145507812)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <!-- sağ yüz -->
            <path
              fill="#e1e8f0"
              fill-opacity="1"
              d=" M-200,-320 C-200,-320 200,-320 200,-320 C200,-320 200,320 200,320 C200,320 -200,320 -200,320 C-200,320 -200,-320 -200,-320z"
            ></path>
          </g>
        </g>
        <g transform="matrix(1,0,0,1,920,450.03741455078125)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <!-- sağ üst kapak -->
            <path
              fill="rgb(208,225,242)"
              fill-opacity="1"
              d=" M240,140 C240,140 -160,140 -160,140 C-160,140 -240,-140 -240,-140 C-240,-140 160,-140 160,-140 C160,-140 240,140 240,140z"
            ></path>
          </g>
        </g>
        <g transform="matrix(1,0,0,1,360,450.03741455078125)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <!-- sol üst kapak -->
            <path
              fill="rgb(208,225,242)"
              fill-opacity="1"
              d=" M240,140 C240,140 -320,140 -320,140 C-320,140 -240,-140 -240,-140 C-240,-140 320,-140 320,-140 C320,-140 240,140 240,140z"
            ></path>
          </g>
        </g>
        <g transform="matrix(1,0,0,1,540,890.0374145507812)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(208,225,242)"
              fill-opacity="1"
              d=" M80,20 C80,20 -80,20 -80,20 C-91.0459976196289,20 -100,11.045999526977539 -100,0 C-100,0 -100,0 -100,0 C-100,-11.045999526977539 -91.0459976196289,-20 -80,-20 C-80,-20 80,-20 80,-20 C91.0459976196289,-20 100,-11.045999526977539 100,0 C100,0 100,0 100,0 C100,11.045999526977539 91.0459976196289,20 80,20z"
            ></path>
          </g>
        </g>
        <g transform="matrix(0.9862974286079407,0,0,1,984.5552368164062,900)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(242,73,96)"
              fill-opacity="1"
              d=" M139.5,0 C139.5,77.31999969482422 77.04399871826172,140 0,140 C-77.04399871826172,140 -139.5,77.31999969482422 -139.5,0 C-139.5,-77.31999969482422 -77.04399871826172,-140 0,-140 C77.04399871826172,-140 139.5,-77.31999969482422 139.5,0z"
            ></path>
          </g>
        </g>
        <g transform="matrix(0.09787514805793762,0,0,1,979,900)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <path fill="rgb(242,73,96)" fill-opacity="1" d=" M20,140 C20,140 -20,140 -20,140 C-20,140 -20,-140 -20,-140 C-20,-140 20,-140 20,-140 C20,-140 20,140 20,140z"></path>
          </g>
        </g>
        <g transform="matrix(0.9862974286079407,0,0,1,974.4747924804688,900)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(255,99,121)"
              fill-opacity="1"
              d=" M139.5,0 C139.5,77.31999969482422 77.04399871826172,140 0,140 C-77.04399871826172,140 -139.5,77.31999969482422 -139.5,0 C-139.5,-77.31999969482422 -77.04399871826172,-140 0,-140 C77.04399871826172,-140 139.5,-77.31999969482422 139.5,0z"
            ></path>
          </g>
        </g>
        <g transform="matrix(0.9862974286079407,0,0,1,559.7366943359375,560)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(255,255,255)"
              fill-opacity="1"
              d=" M392.51800537109375,307.7120056152344 C398.135986328125,298.9020080566406 407.4630126953125,294.4960021972656 420.5,294.4960021972656 C433.53399658203125,294.4960021972656 442.8630065917969,298.9020080566406 448.4830017089844,307.7120056152344 C454.1000061035156,316.52398681640625 456.9110107421875,328.70599365234375 456.9110107421875,344.25799560546875 C456.9110107421875,359.9010009765625 454.1000061035156,372.1730041503906 448.4830017089844,381.072998046875 C442.8630065917969,389.9729919433594 433.53399658203125,394.42401123046875 420.5,394.42401123046875 C407.4630126953125,394.42401123046875 398.135986328125,389.9729919433594 392.51800537109375,381.072998046875 C386.89801025390625,372.1730041503906 384.0889892578125,359.9010009765625 384.0889892578125,344.25799560546875 C384.0889892578125,328.70599365234375 386.89801025390625,316.52398681640625 392.51800537109375,307.7120056152344z M437.0199890136719,327.4679870605469 C436.1650085449219,322.9289855957031 434.4570007324219,319.22100830078125 431.8949890136719,316.3429870605469 C429.3330078125,313.4670104980469 425.53399658203125,312.0270080566406 420.5,312.0270080566406 C415.4639892578125,312.0270080566406 411.6669921875,313.4670104980469 409.1050109863281,316.3429870605469 C406.5429992675781,319.22100830078125 404.8340148925781,322.9289855957031 403.9800109863281,327.4679870605469 C403.125,332.0090026855469 402.6990051269531,337.6059875488281 402.6990051269531,344.25799560546875 C402.6990051269531,351.09100341796875 403.10400390625,356.822998046875 403.9129943847656,361.4519958496094 C404.72198486328125,366.0830078125 406.4280090332031,369.81298828125 409.0369873046875,372.6449890136719 C411.64300537109375,375.47698974609375 415.4639892578125,376.89300537109375 420.5,376.89300537109375 C425.53399658203125,376.89300537109375 429.35400390625,375.47698974609375 431.9630126953125,372.6449890136719 C434.5690002441406,369.81298828125 436.27801513671875,366.0830078125 437.0870056152344,361.4519958496094 C437.89599609375,356.822998046875 438.3009948730469,351.09100341796875 438.3009948730469,344.25799560546875 C438.3009948730469,337.6059875488281 437.87298583984375,332.0090026855469 437.0199890136719,327.4679870605469z"
            ></path>
          </g>
        </g>
      </g>
    </svg>

    <slot />
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: "300px",
    },
  },
};
</script>
